import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <Section className="text-center py-20" data-id="element-23">
      <p className="text-xl md:text-2xl font-serif text-warm-brown mb-8" data-id="element-24">
        Si hoy tu espiritualidad te está pesando… <br data-id="element-25" />
        probá una versión más humana.
      </p>

      <h2 className="text-3xl md:text-4xl font-serif font-bold text-terracotta mb-10" data-id="element-26">
        Calma Espiritual (7 días)
      </h2>

      <div className="space-y-2 mb-12 text-lg text-sage font-medium tracking-wide" data-id="element-27">
        <p data-id="element-28">14 minutos por día.</p>
        <p data-id="element-29">Sin mística rara.</p>
        <p data-id="element-30">Con repetición.</p>
      </div>

      <div className="mb-10" data-id="element-31">
        <p className="text-warm-brown/50 line-through text-lg mb-1" data-id="element-32">
          $14.900 ARS
        </p>
        <p className="text-4xl md:text-5xl font-serif font-bold text-terracotta" data-id="element-33">
          $8.900{' '}
          <span className="text-lg font-medium text-warm-brown/70" data-id="element-34">ARS</span>
        </p>
        <p className="text-sage text-sm mt-2 italic" data-id="element-35">
          Precio promocional por tiempo limitado
        </p>
      </div>

      <motion.a id="final-cta" href="https://argrutinas.com/cart/42972979069137:1" target="_blank" rel="noopener noreferrer" onClick={() => {
      if ((window as any).fbq) {
        ;
        (window as any).fbq('track', 'AddToCart');
      }
    }} whileHover={{
      scale: 1.05
    }} whileTap={{
      scale: 0.95
    }} className="inline-block bg-terracotta text-cream px-10 py-5 rounded-full text-xl font-medium shadow-xl hover:bg-terracotta-dark transition-colors animate-breathing" data-id="element-36">
        Quiero mi Protocolo 7×7
      </motion.a>
    </Section>;
}